import React, { useCallback } from 'react';

// DEPENDENCIES
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import { useFormikContext } from 'formik';

// GLOBAL VARIABLES
import { INTERFACE } from 'pathnames.js';

// GLOBAL FUNCTIONS
import { makePath } from 'functions';

// GLOBAL COMPONENTS
import Form from 'core/form/Form';

// LOCAL COMPONENTS
import HeaderSelect from '../layout/HeaderSelect';

// STYLES
import styles from './searchForm.module.scss';

// GLOBAL FUNCTIONS
import { preferenceActions } from 'actions.js';

// VARIABLES
const OPTIONS = [
  {
    label: 'VIN #',
    value: 'vin_num'
  },
  {
    label: 'Stock #',
    value: 'stock_num'
  },
  {
    label: 'Customer',
    value: 'customer'
  },
  {
    label: 'Salesperson',
    value: 'salesperson'
  },
  {
    label: 'Customer #',
    value: 'customer_number'
  },
  {
    label: 'Deal #',
    value: 'deal_number'
  }
];

// FUNCTIONS
const isResultPage = pathname => makePath(pathname) === makePath(INTERFACE.search);

// MAIN COMPONENT
const SearchFormFields = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const { search: { filters } = {} } = useSelector(state => state.preferences);
  const dispatch = useDispatch();

  const { values = {} } = useFormikContext();

  // CALLBACKS
  const updateFilters = useCallback(
    preference => {
      dispatch(
        preferenceActions.updatePreference('search', {
          filters: {
            ...filters,
            ...preference
          }
        })
      );
    },
    [dispatch, filters]
  )
  const handleSearch = useCallback(
    (searchField) => {
      if (!values.searchKeyword) return;
      updateFilters({
        searchField,
        searchKeyword: values.searchKeyword
      })
      if (!isResultPage(pathname)) navigate(makePath(INTERFACE.search));
    },
    [values.searchKeyword, updateFilters, pathname, navigate]
  )
  const handleKeyDown = useCallback(
    ({ key }) => {
      if (key === 'Enter') handleSearch(values.searchField);
    },
    [handleSearch, values.searchField]
  )

  // RENDER
  return (
    <Form.Group>
      <Form.Control
        name="searchKeyword"
        placeholder="Search"
        onKeyDown={handleKeyDown}
        prepend={{
          use: 'search',
          onClick: () => handleSearch(values.searchField)
        }}
        className="ms-0"
        formGroup={{
          className: styles.keyword
        }}
      />
      <HeaderSelect
        name="searchField"
        placeholder="Category"
        options={OPTIONS}
        onSelect={handleSearch}
        formGroup={{
          className: styles.category
        }}
      />
    </Form.Group>
  );
};

// EXPORT
export default function SearchForm() {
  const { search: { filters } = {} } = useSelector(state => state.preferences);

  const { pathname } = useLocation();

  return (
    <div className={styles.container}>
      <Form
        initialValues={isResultPage(pathname) ? filters : undefined}
      >
        <SearchFormFields />
      </Form>
    </div>
  );
};
